/** SUNTRONIX ONE — EmptyState (ONE VIBE).
 *  A pleasant, contextual empty state with an icon and an optional action.
 *  Kept compact — no giant illustrations.
 */
import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, hint, action, testid = "empty-state" }) {
  return (
    <div data-testid={testid}
      className="flex flex-col items-center justify-center text-center py-14 px-6">
      <div className="h-12 w-12 rounded-xl bg-slate-50 border border-slate-200 grid place-items-center text-slate-400 mb-3">
        <Icon className="h-6 w-6" strokeWidth={1.6} />
      </div>
      <div className="text-sm font-semibold text-slate-800">{title}</div>
      {hint && <div className="text-[12px] text-slate-500 mt-1 max-w-sm">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
